import { baseUrl } from "util/APIBaseUrl";
import getRequest from "util/APIHelperGet";
import postRequest from "util/APIHelperPost";

const root = `${baseUrl}/v4`;

// Fetches the caller's CURRENT permissions/features from the backend.
// The route is `/me/permissions` (the default-version middleware prepends `/v1/`),
// matching how other non-`/vN`-prefixed backend calls are made (e.g. `user/:id/summary`).
export const getMyPermissions = async () => {
  const res = await getRequest(`${baseUrl}/me/permissions`, false);
  return res?.ok ? res.payload : null;
};

// Re-fetches the caller's CURRENT permissions on bootstrap so role-permission
// changes made by an admin reflect on the user's next page reload.
// Runs only when authenticated (accessToken present). On success it overwrites
// `localStorage.permissionTable` so the synchronous, non-reactive `hasPermission`
// flag gates read a fresh snapshot. On failure (network/401) it fails soft:
// the last-known table is left untouched (login/refresh path still maintains it).
export const refreshPermissionTable = async () => {
  if (!localStorage.getItem("accessToken")) return;
  try {
    const table = await getMyPermissions();
    if (table && Array.isArray(table.permissions) && Array.isArray(table.features)) {
      localStorage.setItem(
        "permissionTable",
        JSON.stringify({ permissions: table.permissions, features: table.features })
      );
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Failed to refresh permission table on bootstrap:", error);
  }
};

export const getRoles = async () => {
  const res = await getRequest(`${root}/roles`, false);
  return res.ok ? res.payload : [];
};
export const getRole = async (roleId) => {
  const res = await getRequest(`${root}/roles/${roleId}`, false);
  return res.ok ? res.payload : null;
};
export const getCatalog = async () => {
  const res = await getRequest(`${root}/rbac/catalog`, false);
  return res.ok ? res.payload : [];
};
export const createRole = (body) => postRequest(`${root}/roles`, JSON.stringify(body), true);
export const updateRole = (roleId, body) => postRequest(`${root}/roles/${roleId}`, JSON.stringify(body), true, "PATCH");
export const deleteRole = (roleId) => postRequest(`${root}/roles/${roleId}`, undefined, true, "DELETE");
export const assignRole = (roleId, principalType, principalId) =>
  postRequest(`${root}/roles/${roleId}/assign`, JSON.stringify({ principalType, principalId }), true);
export const createFeature = (body) => postRequest(`${root}/features`, JSON.stringify(body), true);
export const updateFeature = (featureId, body) => postRequest(`${root}/features/${featureId}`, JSON.stringify(body), true, "PATCH");
export const deleteFeature = (featureId) => postRequest(`${root}/features/${featureId}`, undefined, true, "DELETE");
export const createPermission = (body) => postRequest(`${root}/permissions`, JSON.stringify(body), true);
export const updatePermission = (permissionId, body) => postRequest(`${root}/permissions/${permissionId}`, JSON.stringify(body), true, "PATCH");
export const deletePermission = (permissionId) => postRequest(`${root}/permissions/${permissionId}`, undefined, true, "DELETE");
